import {
  BothBorders,
  BottomBorder,
  LeftBorder,
  RightBorder,
  TopBorder,
} from '../../../core/components/threshold-bar/types.js';
import type { XYChartAxisInternal } from '../../types/xy-chart-internals.js';

export function getBorderThresholds(
  left: XYChartAxisInternal | undefined,
  right: XYChartAxisInternal | undefined,
  top: XYChartAxisInternal | undefined,
  bottom: XYChartAxisInternal | undefined,
) {
  const leftBorder = !left || left.hidden ? BothBorders : LeftBorder;
  const rightBorder = !right || right.hidden ? BothBorders : RightBorder;
  const topBorder = !top || top.hidden ? BothBorders : TopBorder;
  const bottomBorder = !bottom || bottom.hidden ? BothBorders : BottomBorder;
  return { leftBorder, rightBorder, topBorder, bottomBorder };
}
